export function normalizeAuthReturnPath(value: string | null | undefined) {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return null
  return value
}

export function getLogoutDestination(returnTo?: string) {
  return normalizeAuthReturnPath(returnTo) ?? '/auth/signed-out'
}
